module.exports = require("scrypt.js");